module.exports = __webpack_public_path__ + "static/media/1.ab77052a.jpg";